import React, { FC } from 'react';
import styled from 'styled-components';

import HeaderCard, { IHeaderCardProps } from '@ui/atoms/HeaderCard';
import TextButton from '@ui/atoms/TextButton';

import theme from '@theme/FolxTheme';

interface IProductSummaryCardProps extends IHeaderCardProps {
	handleClick: () => void;
	name: string;
	disabled?: boolean;
	label?: string;
}

const Card = styled(HeaderCard)<{ disabled: boolean }>`
	background-color: ${({ disabled }) => disabled && theme.colors.gray};
`;

const ProductSummaryCard: FC<IProductSummaryCardProps> = ({
	className,
	disabled = false,
	handleClick,
	header,
	label = 'Edit',
	name,
	subheader,
}) => {
	return (
		<Card
			className={className}
			disabled={disabled}
			header={header}
			subheader={subheader}
			name={name}>
			<TextButton
				disabled={disabled}
				name={name}
				label={label}
				variant="text"
				underline
				onClick={handleClick}
			/>
		</Card>
	);
};

export default styled(ProductSummaryCard)``;
